import React, { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Email, Public, Phone, LinkedIn } from '@mui/icons-material';
import LoginPopup from '@/common/LoginPopup';

function ContactSection({ VendorDetail }) {
  const [venderdetail] = useState(VendorDetail);
  const [showPopup, setShowPopup] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const isAuthenticated = Boolean(localStorage.getItem("access_token"));

  const handleBlurClick = () => {
    if (!isAuthenticated) {
      setRedirectUrl("/customer/auth/login");
      setShowPopup(true);
    }
  };

  // Helper to mask values
  const maskValue = (value) => {
    if (!isAuthenticated) {
      return "xxxx";
    }
    return value || "";
  };

  return (
    <section>
      <Box
        sx={{
          backgroundColor: '#fbfcff',
          border: '1px solid #d9d9d9',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          width: '100%',
          mt: 1,
          padding: '8px 38px',
          fontFamily: 'Poppins, -apple-system, Roboto, Helvetica, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1,
          position: 'relative',
          cursor: !isAuthenticated ? 'pointer' : 'default'
        }}
        onClick={!isAuthenticated ? handleBlurClick : undefined}
      >
        <Typography variant="h6" fontWeight={600}>
          Contact Information
        </Typography>

        <Box
          sx={{
            filter: !isAuthenticated ? 'blur(2px)' : 'none',
            mt: 1
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Email sx={{ color: '#6d50e2' }} />
              <span style={{ color: '#6e6d6a', width: '300px' }}>
                {maskValue(venderdetail.work_email)}
              </span>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Public sx={{ color: '#6d50e2' }} />
              <span style={{ color: '#6e6d6a', width: '300px' }}>
                {maskValue(venderdetail.website)}
              </span>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%', marginTop: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Phone sx={{ color: '#6d50e2' }} />
              <span style={{ color: '#6e6d6a', width: '300px' }}>
                {maskValue(venderdetail.phone_number)}
              </span>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LinkedIn sx={{ color: '#6d50e2' }} />
              <span style={{ color: '#6e6d6a', width: '300px' }}>
                {maskValue(venderdetail.linkedin)}
              </span>
            </Box>
          </Box>
        </Box>
      </Box>

      {showPopup && (
        <LoginPopup
          onClose={() => setShowPopup(false)}
          redirectUrl={redirectUrl}
        />
      )}
    </section>
  );
}

export default ContactSection;
